var _defs, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFuelType4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SVGDoc",
    width: 72,
    height: 72,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-32c88e6e-a832-43c1-abfb-db52a62434c0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,72v0v-72v0h72v0v72v0z"
  })))), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Generated with Avocode.")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Gruppe 3303"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Rechteck 2514")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-32c88e6e-a832-43c1-abfb-db52a62434c0)"
  }, /*#__PURE__*/React.createElement("title", null, "Pfad 5841"), /*#__PURE__*/React.createElement("path", {
    d: "M43.619,56.504v0h9.788c0.691,0 1.251,-0.56 1.251,-1.251v-35.091v0",
    fillOpacity: 0,
    fill: "#ffffff",
    strokeDashoffset: 0,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 1,
    stroke: "#004a5a",
    strokeMiterlimit: 20,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-32c88e6e-a832-43c1-abfb-db52a62434c0)"
  }, /*#__PURE__*/React.createElement("title", null, "Pfad 5842"), /*#__PURE__*/React.createElement("path", {
    d: "M5.416,56.503c-0.838,0 -1.459,-0.852 -1.126,-1.621c0.686,-1.582 2.134,-2.757 3.883,-3.063c0.513,-0.09 0.898,-0.487 0.99,-0.999c0.434,-2.444 2.57,-4.3 5.139,-4.3c1.898,0 3.559,1.014 4.472,2.529c0.315,0.523 0.986,0.699 1.532,0.427c0.701,-0.35 1.491,-0.548 2.325,-0.548c1.197,0 2.301,0.405 3.181,1.082c0,0 2.778,1.819 2.778,6.495z",
    fillOpacity: 0,
    fill: "#ffffff",
    strokeDashoffset: 0,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 1,
    stroke: "#004a5a",
    strokeMiterlimit: 20,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-32c88e6e-a832-43c1-abfb-db52a62434c0)"
  }, /*#__PURE__*/React.createElement("title", null, "Pfad 5843"), /*#__PURE__*/React.createElement("path", {
    d: "M7.077,29.078v0l28.082,-24.765c0.473,-0.417 1.181,-0.417 1.654,0l28.081,24.765v0",
    fillOpacity: 0,
    fill: "#ffffff",
    strokeDashoffset: 0,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 1,
    stroke: "#004a5a",
    strokeMiterlimit: 20,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-32c88e6e-a832-43c1-abfb-db52a62434c0)"
  }, /*#__PURE__*/React.createElement("title", null, "Linie 546"), /*#__PURE__*/React.createElement("path", {
    d: "M17.3136,46.7694v-26.607",
    fillOpacity: 0,
    fill: "#ffffff",
    strokeDashoffset: 0,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 1,
    stroke: "#004a5a",
    strokeMiterlimit: 20,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-32c88e6e-a832-43c1-abfb-db52a62434c0)"
  }, /*#__PURE__*/React.createElement("title", null, "Pfad 5844"), /*#__PURE__*/React.createElement("path", {
    d: "M54.658,49.297c0.925,0.213 1.761,0.663 2.439,1.283c0.457,0.417 1.167,0.405 1.625,-0.011c1.13,-1.025 2.688,-1.583 4.379,-1.361c2.338,0.306 4.26,2.175 4.631,4.504c0.098,0.622 0.091,1.225 -0.007,1.798c-0.099,0.583 -0.635,0.993 -1.226,0.993l-1.783,0.001v0l-10.525,-0.001v0",
    fillOpacity: 0,
    fill: "#ffffff",
    strokeDashoffset: 0,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 1,
    stroke: "#004a5a",
    strokeMiterlimit: 20,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-32c88e6e-a832-43c1-abfb-db52a62434c0)"
  }, /*#__PURE__*/React.createElement("title", null, "Pfad 5845"), /*#__PURE__*/React.createElement("path", {
    d: "M37.24,42.973v0c0,0 -2.136,-3.009 -2.029,-6.366c0.144,-4.473 2.788,-4.388 2.932,-8.862c0.106,-3.307 -1.998,-6.273 -1.998,-6.273v0",
    fillOpacity: 0,
    fill: "#ffffff",
    strokeDashoffset: 0,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 1,
    stroke: "#004a5a",
    strokeMiterlimit: 20,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-32c88e6e-a832-43c1-abfb-db52a62434c0)"
  }, /*#__PURE__*/React.createElement("title", null, "Pfad 5846"), /*#__PURE__*/React.createElement("path", {
    d: "M46.286,42.973v0c0,0 -2.136,-3.009 -2.029,-6.366c0.144,-4.473 2.788,-4.388 2.932,-8.862c0.106,-3.307 -1.998,-6.273 -1.998,-6.273v0",
    fillOpacity: 0,
    fill: "#ffffff",
    strokeDashoffset: 0,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 1,
    stroke: "#004a5a",
    strokeMiterlimit: 20,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-32c88e6e-a832-43c1-abfb-db52a62434c0)"
  }, /*#__PURE__*/React.createElement("title", null, "Pfad 5847"), /*#__PURE__*/React.createElement("path", {
    d: "M28.193,42.973v0c0,0 -2.136,-3.009 -2.029,-6.366c0.144,-4.473 2.788,-4.388 2.932,-8.862c0.106,-3.307 -1.998,-6.273 -1.998,-6.273v0",
    fillOpacity: 0,
    fill: "#ffffff",
    strokeDashoffset: 0,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 1,
    stroke: "#004a5a",
    strokeMiterlimit: 20,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-32c88e6e-a832-43c1-abfb-db52a62434c0)"
  }, /*#__PURE__*/React.createElement("title", null, "Linie 547"), /*#__PURE__*/React.createElement("path", {
    d: "M68.3984,67.3984h-64.398",
    fillOpacity: 0,
    fill: "#ffffff",
    strokeDashoffset: 0,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 1,
    stroke: "#004a5a",
    strokeMiterlimit: 20,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-32c88e6e-a832-43c1-abfb-db52a62434c0)"
  }, /*#__PURE__*/React.createElement("title", null, "Linie 548"), /*#__PURE__*/React.createElement("path", {
    d: "M36,50.1538v17.245",
    fillOpacity: 0,
    fill: "#ffffff",
    strokeDashoffset: 0,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 1,
    stroke: "#004a5a",
    strokeMiterlimit: 20,
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelType4);
export default __webpack_public_path__ + "static/media/fuel-type-4.be18c6de02e58d4dd7c0edbb7cb4bff7.svg";
export { ForwardRef as ReactComponent };